import { mapActions } from 'vuex';
import { MODALS } from '@/components/app/app-modals/app-modals';

export default {
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    onCancel() {
      this.setCurrentPopup(MODALS.LOGIN);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-forgotten/footer/footer.js